/**
 * The team pane while its read is out, or after it failed.
 *
 * The failure itself is stated in the status band above; this is the way back.
 *
 * @module components/teams/TeamReadState
 */

import React from "react";

import { Button, Panel } from "@/components/ui";
import { Bone, SkeletonTable } from "@/components/ui/SkeletonParts";

export function TeamReadState({
  loading,
  onRetry,
}: {
  loading: boolean;
  onRetry: () => void;
}): React.ReactElement {
  if (loading) {
    return (
      <div role="status" aria-live="polite" data-testid="assignments-loading">
        <span className="sr-only">Loading this programme&apos;s team…</span>
        {/* The People and Modules tabs over the permissions table. */}
        <div aria-hidden="true">
          <div className="flex gap-2 px-2">
            <Bone className="h-9 w-20 rounded-b-none" />
            <Bone className="h-9 w-20 rounded-b-none" />
          </div>
          <Panel flush className="flex flex-col gap-4 p-4">
            <div className="flex items-center justify-between gap-3">
              <Bone className="h-4 w-72" />
              <Bone className="h-8 w-28" />
            </div>
            <SkeletonTable columns={6} rows={3} />
          </Panel>
        </div>
      </div>
    );
  }
  return (
    <Button size="sm" variant="outline" icon="arrow-clockwise" onClick={onRetry}>
      Try again
    </Button>
  );
}
